'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.driveOpenLinkWidget = function (config, navigatorModel) {
	const mobile = navigatorModel.isMobile() ? 'mobile/' : '';
	return mmWidgets.each(this, function () {
		this.attr('href', `https://drive.google.com/drive/${mobile}search?q=type%3Aapplication%2Fvnd.mindmup`);
	});
};
